import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    copied: {
        id: "input.copiedToTheClipboard",
    },
});

export default messages;
